import {
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { LTA_module } from "../../../services/lta_module";

/**
 * "Type of Metal Loss" radio-button selector for LTAP tanks mode.
 * Owns the LTA/Groove selection and controls the ltap_grooveRadius_gr field state.
 */
@Component({
  selector: "tanks-ltap-metal-loss-type",
  templateUrl: "./tanks-ltap-metal-loss-type.component.html",
  standalone: false,
})
export class TanksLtapMetalLossTypeComponent implements OnInit {
  @Input() formGroup: FormGroup;

  selectedMetalLossType: string = "LTA";

  ngOnInit(): void {
    // LTA is default, so radius field starts disabled
    this.applyGrControlState(this.selectedMetalLossType);
  }

  onMetalLossTypeChange(type: string): void {
    this.selectedMetalLossType = type;
    this.applyGrControlState(type);
  }

  private applyGrControlState(type: string): void {
    LTA_module.intLTA_type = type === "Groove" ? 1 : 0;
    const grControl = this.formGroup?.get("ltap_grooveRadius_gr");
    if (!grControl) return;
    if (type === "Groove") {
      grControl.enable();
    } else {
      grControl.disable();
    }
  }
}
